import { render, staticRenderFns } from "./DlxDownload.vue?vue&type=template&id=4f57ba33&scoped=true&"
import script from "./DlxDownload.vue?vue&type=script&lang=js&"
export * from "./DlxDownload.vue?vue&type=script&lang=js&"
import style0 from "./DlxDownload.vue?vue&type=style&index=0&id=4f57ba33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f57ba33",
  null
  
)

export default component.exports